import { render } from "./SubmitCampaign.vue?vue&type=template&id=43bd3be4"
import script from "./SubmitCampaign.vue?vue&type=script&lang=js"
export * from "./SubmitCampaign.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__